// src/services/FetchLocations.js (for example)

import { baseUrl_SPB } from "../BaseUrl";


const FetchLocationsService = async (token) => {
  try {
    const response = await fetch(`${baseUrl_SPB}/api/v1/company/getlocationsbycompanyid`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch location data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching locations:', error);
    return null;
  }
};

export default FetchLocationsService;
